import React from 'react';
import { Label } from 'office-ui-fabric-react';

const ErrorLabel = (props) => {
  let modProps = Object.assign({}, props);
  delete modProps.children;
  delete modProps.className;
  return (
    <Label {...modProps} className="error-label">
      {props.children}
    </Label>
  );
};

export { ErrorLabel };
